import Vue from 'vue';
import VueI18n from 'vue-i18n';
import DE_TRANSLATIONS from '../translations/ge';
import EN_TRANSLATIONS from '../translations/en';
import FR_TRANSLATIONS from '../translations/fr';
import NL_TRANSLATIONS from '../translations/nl';

Vue.use(VueI18n);

const TRANSLATIONS = {
	'de-DE': { ...DE_TRANSLATIONS },
	'en-EN': { ...EN_TRANSLATIONS },
	'en-US': { ...EN_TRANSLATIONS },
	'fr-CH': { ...FR_TRANSLATIONS },
	'nl-NL': { ...NL_TRANSLATIONS },
};

export default new VueI18n({
	locale: 'de-DE',
	fallbackLocale: 'de-DE',
	messages: TRANSLATIONS,
});

// Vue.moment().locale('de-at');
